<template>
  <v-app>
    <v-navigation-drawer
      clipped
      app
      v-model="drawer"
      width="280"
      color="white"
      v-if="this.$store.getters.message"
    >
      <v-container>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title" style="text-align: center">
              <img
                width="60%"
                src="https://appmedia.co.jp/wp-content/uploads/2020/01/logo_0129.png"
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list nav dense>
          <template v-for="nav_list in nav_lists">
            <v-list-item
              v-if="!nav_list.lists"
              :to="nav_list.link"
              :key="nav_list.name"
              @click="menu_close"
            >
              <div :class="borderTop(nav_list.border)"></div>
              <v-list-item-icon class="mr-3">
                <v-icon>{{ nav_list.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-2">
                  {{
                  nav_list.name
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              v-else
              no-action
              :key="nav_list.name"
              v-model="nav_list.active"
              :class="borderTop(nav_list.border)"
            >
              <template v-slot:activator>
                <v-list-item-icon class="mr-3">
                  <v-icon>{{ nav_list.icon }}</v-icon>
                  <div v-if="typeof nav_list.img != 'undefined' && nav_list.img != ''">
                    <v-img width="30" height="30" :src="nav_list.img"></v-img>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="body-2">
                    {{
                    nav_list.name
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="list in nav_list.lists" :key="list.name" :to="list.link">
                <v-list-item-title class="body-2">
                  {{
                  list.name
                  }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list>
      </v-container>
    </v-navigation-drawer>

    <v-app-bar clipped-left app flat dark color="blue-grey darken-2" class="pl-6">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/" class="white--text">
          {{
          title
          }}
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn text to="/enterprise">For Enterprise</v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" text>
              Support
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-subheader>Get help</v-subheader>
            <v-list-item v-for="support in supports" :key="support.name" :to="support.link">
              <v-list-item-icon>
                <v-icon>{{ support.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ support.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>-->
    </v-app-bar>

    <v-content style="background-color: #f4f4f4">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";

export default {
  methods: {
    menu_close() {
      this.nav_lists.forEach(nav_list => (nav_list.active = false));
    },
    borderTop(border) {
      if (typeof border != "undefined" && border == "on") {
        return "border-top";
      } else {
        return "";
      }
    }
  },
  computed: {
    // bg() {
    //   return require("@/assets/img/sidebar-2.jpg");
    // }
  },
  data() {
    return {
      title: "AppMedia管理 (" + process.env.NODE_ENV + ")",
      drawer: null,
      supports: [
        {
          name: "Consulting and suppourt",
          icon: "mdi-vuetify",
          link: "/consulting-and-support"
        },
        {
          name: "Discord community",
          icon: "mdi-discord",
          link: "/discord-community"
        },
        {
          name: "Report a bug",
          icon: "mdi-bug",
          link: "/report-a-bug"
        },
        {
          name: "Github issue board",
          icon: "mdi-github-face",
          link: "/guthub-issue-board"
        },
        {
          name: "Stack overview",
          icon: "mdi-stack-overflow",
          link: "/stack-overview"
        }
      ],
      nav_lists: [],
      test_message: "AAAA"
    };
  },

  mounted() {
    var self = this;

    // ユーザログインのチェック
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // console.log("ログイン中22", user.email);

        if (user.email != "writer@appmedia.jp") {
          self.nav_lists = [
            {
              name: "このサイトについて",
              icon: "mdi-speedometer",
              link: "/about"
            },
            {
              name: "リダイレクト管理",
              icon: "mdi-cogs",
              link: "/redirect_system",
              lists: [
                {
                  name: "管理画面",
                  link: "/redirect_top"
                },
                {
                  name: "仕様",
                  link: "/redirect_help"
                }
              ]
            },

            {
              name: "広告管理",
              icon: "mdi-sack",
              link: "/linkcode"
            },

            // {
            //   name: "広告管理",
            //   icon: "mdi-sack",
            //   lists: [
            //     {
            //       name: "リンクコード画面",
            //       link: "/linkcode"
            //     },
            //                     {
            //       name: "インステ設定値チェッカー",
            //       link: "/inste_checker"
            //     }
            //   ]

            // },

            {
              name: "アプリデータベース",
              icon: "mdi-cogs",
              lists: [
                {
                  name: "管理画面",
                  link: "/appli_db"
                }
              ]
            },

            {
              name: "エンジニア管理",
              icon: "mdi-cogs",
              link: "/about",
              lists: [
                {
                  name: "管理画面",
                  link: "/engineer"
                }
              ]
            },

            {
              name: "アプリ新作カレンダー",
              icon: "mdi-calendar",
              link: "/app_calendar"
            },
            {
              name: "おすすめアプリゲーム",
              icon: "mdi-cards-heart",
              link: "/recommendAppli"
            },

            {
              name: "Discord予約投稿",
                icon: "mdi-alpha-d-box",
              lists: [
                {
                  name: "管理画面",
                  link: "/discord_post"
                }
              ]
            },

          ];
        }

        self.nav_lists.push(
          {
            name: "掲示板・レビュー管理",
            icon: "mdi-comment-multiple",
            link: "/about",
            lists: [

              {
                name: "レビュー管理",
                icon: "mdi-pencil",
                link: "/Review"
              },
              // {
              //   name: "デッキ投稿管理(マジカミ)",
              //   icon: "mdi-pencil",
              //   link: "/deck_manager"
              // },
              {
                name: "フレ募集/編成投稿掲示板",
                icon: "mdi-account-plus",
                link: "/friend_bbs"
              }
            ]
          },

          {
            name: "マップ生成",
            icon: "mdi-map",
            link: "/map_generate"
          },

          {
            name: "マスターデュエル",
            // icon: "mdi-cards-playing",
            border: "on",
            img:
              "https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/yugi_rush.png",
            link: "/about",
            lists: [
              // {
              //   name: "カード管理(作成中)",
              //   icon: "mdi-cards-playing",
              //   link: "/master_duel_card"
              // },
              // {
              //   name: "デッキ管理(作成中)",
              //   icon: "mdi-cards-playing",
              //   link: "/master_duel_deck"
              // },
              {
                name: "リミット管理(作成中)",
                icon: "mdi-cards-playing",
                link: "/master_duel_limit"
              }
            ]
          },

          {
            name: "ラッシュデュエル",
            // icon: "mdi-cards-playing-outline",
            img:
              "https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/jounouchi.webp",
            link: "/about",
            lists: [
              {
                name: "カード管理",
                icon: "mdi-cards-playing",
                link: "/rush_duel_card"
              },
              {
                name: "デッキ管理",
                icon: "mdi-cards-playing",
                link: "/rush_duel_deck"
              },
              {
                name: "入手方法管理",
                icon: "mdi-cards-playing",
                link: "/rush_duel_getmaster"
              }
            ]
          }
        );
      }
    });
  }

  // mounted() {
  //   console.log(process.env.NODE_ENV);
  // },
};
</script>
<style>
/* 必須 */
/* html{
  overflow: hidden !important;
}

.v-content__wrap{
  overflow: scroll !important;
} */

.content_header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  box-shadow: 0 1px 6px #bbb;
}

.router-link-active {
  text-decoration: none;
}

.v-navigation-drawer__content
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 35px;
}

/* 必須 */

* :not(.v-icon) {
  font-family: Arial, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka,
    メイリオ, Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
}

table td {
  word-break: break-all;
  min-width: 50px;
}
.v-data-table__mobile-row__header {
  min-width: 50px;
}

/* .v-data-table table{
  border: 1px solid #eee;
}
.v-data-table td {
  border-right: 1px solid #eee;
}
.v-data-table td:last-child {
  border-right: none;
}

.theme--light.v-data-table thead tr th {
    background: #ecf1fa;
    border-right: 1px solid #ddd;
}
.theme--light.v-data-table thead tr th span{
  color: #333;
}
.fa-sort-up:before{
  color: #333;
} */

.theme--light.v-data-table thead tr th span,
.v-data-table__wrapper thead th {
  color: #4caf50 !important;
  font-size: 15px;
  font-weight: normal;
}
.fa-sort-up:before {
  color: #4caf50;
  padding: 0 4px;
}
/* .v-data-table td, .v-data-table th{
  padding: 6px !important;;
} */
.fa-chevron-down:before {
  font-size: 16px;
}
/* tbody tr:nth-of-type(odd) {
  background-color: rgba(184, 184, 58, 0.06);
} */

/* .v-navigation-drawer__content {
  background-image: linear-gradient(rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.72));
} */

/* .v-list-item--active:not(.v-list-group__header) {
  background-color: #ffffff24;
} */
.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
  opacity: 0;
}

.border-top {
  border-top: 1px dashed #455a64;
  margin-top: 15px;
  padding-top: 15px;
}

/* .v-list-item--active.v-list-group__header {
  color: #fff !important;
}

.v-list-item--active:not(.v-list-group__header) .v-list-item__title {
  color: #fff !important;
} */

/* .v-navigation-drawer__content .v-list-item__title , .v-navigation-drawer__content .v-list-item__icon i{
  color: #fff;;
}
.v-navigation-drawer__content .v-application .primary--text{
  color: #fff !important;
} */
/* .v-list-item--active{
  background: green;;
}


.v-list-item--active .v-list-item__title{
  color: #fff;
 v-list-item v-list-item--active v-list-item--link theme--dark
} */
</style>
